<div>
    <br />
    <div class="form-container">
        <form
            name="redeem-product-code-form"
            [formGroup]="userForm"
            (ngSubmit)="onSubmit()"
        >
            <div class="row invoice-detail">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <app-page-title [title]="'PRODUCT KEY'"></app-page-title>
                            <p>If you have been issued a voucher with a product key, please enter the key in the field below. The associated product will be added to your account.</p>
                            <div class="filterPanel panel panel-default">
                                <div class="panel-body row">
                                    <div class="col-md-8">
                                        <label>Product Key</label>
                                        <input
                                            class="form-control"
                                            name="Redemption Code"
                                            formControlName="productKey"
                                            placeholder="Enter product key here"
                                            autofocus
                                        />
                                    </div>
                                </div>
                                <div class="panel-body row">
                                    <div class="col-md-8">
                                        <button
                                            type="submit"
                                            class="btn btn-primary"
                                            name="confirmationYesBtn"
                                            [disabled]="userForm.invalid"
                                        >
                                            Use Product Key
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<app-modal
    #confirmRedeemModal
    title="Proceed?"
    body="{{ confirmProductKeyResult }}"
    (clickPositive)="useProductKey()"
    isConfirm="true"
>
</app-modal>

<app-modal
    #successRedeemModal
    title="Success"
    body="{{ productKeyRedeemedResult }}"
>
</app-modal>
